import { forwardRef } from 'react';
import type {
    GridExposedMethods,
    GridSettings,
    OnViewChangedCallback,
} from '~/components/Grid';
import {
    ReportType,
    type TemplateIndex,
} from '../../ReportsIndexPage/Report.types';
import FormsGrid from './FormsGrid';
import EventsGrid from './EventsGrid';
import ClientsGrid from './ClientsGrid';
import GenericDataGrid from './GenericDataGrid';
import {
    ClassesReportObject,
    ClientReportObject,
    PackageGrantObject,
    PaymentReportObject,
} from '~/lib/Api.types';

type ReportGridFactoryProps = {
    initialSettings?: GridSettings;
    onViewChanged?: OnViewChangedCallback<any>;
    type: ReportType;
    templateSelected?: TemplateIndex;
};
const ReportGridFactory = forwardRef<
    GridExposedMethods,
    ReportGridFactoryProps
>(({ initialSettings, onViewChanged, type, templateSelected }, ref) => {
    switch (type) {
        default:
        case ReportType.Classes:
            return (
                <GenericDataGrid<ClassesReportObject>
                    ref={ref}
                    initialSettings={initialSettings}
                    onViewChanged={onViewChanged}
                    templateSelected={templateSelected}
                    type={type}
                />
            );
        case ReportType.Payments:
            return (
                <GenericDataGrid<PaymentReportObject>
                    ref={ref}
                    initialSettings={initialSettings}
                    onViewChanged={onViewChanged}
                    templateSelected={templateSelected}
                    type={type}
                />
            );
        case ReportType.Clients:
            return (
                <ClientsGrid
                    ref={ref}
                    initialSettings={initialSettings}
                    onViewChanged={onViewChanged}
                    templateSelected={templateSelected}
                />
            );
        case ReportType.GiftCertificates:
            return (
                <GenericDataGrid<ClientReportObject>
                    ref={ref}
                    initialSettings={initialSettings}
                    onViewChanged={onViewChanged}
                    templateSelected={templateSelected}
                    type={type}
                />
            );
        case ReportType.PackageGrants:
            return (
                <GenericDataGrid<PackageGrantObject>
                    ref={ref}
                    initialSettings={initialSettings}
                    onViewChanged={onViewChanged}
                    templateSelected={templateSelected}
                    type={type}
                />
            );
        case ReportType.Events:
            return (
                <EventsGrid
                    ref={ref}
                    initialSettings={initialSettings}
                    onViewChanged={onViewChanged}
                    templateSelected={templateSelected}
                />
            );
        case ReportType.Forms:
            return (
                <FormsGrid
                    ref={ref}
                    initialSettings={initialSettings}
                    onViewChanged={onViewChanged}
                    templateSelected={templateSelected}
                />
            );
    }
});
export default ReportGridFactory;
